









































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {ResponsavelHistoricoSms} from '@/model/resource/ResponsavelHistoricoSms'
import {InputResponsavelHistoricoSmsSchema} from '@/schema/resource/ResponsavelHistoricoSms/InputResponsavelHistoricoSmsSchema'

@Component
export default class PersistResponsavelHistoricoSmsView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputResponsavelHistoricoSmsSchema()
  responsavelHistoricoSms = new ResponsavelHistoricoSms()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionCarga.listCarga()
    this.schema.collectionMotorista.listMotorista()
    this.schema.collectionTypeSms.listTypeSms()
    this.schema.collectionResponsavel.listResponsavel()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.responsavelHistoricoSms.getResponsavelHistoricoSms(id)
    }

    $.await.done('getResponsavelHistoricoSms')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.responsavelHistoricoSms.persistResponsavelHistoricoSms()
    await Helper.successAndPush(
      'system.success.persist',
      '/responsavel-historico-sms/list'
    )
  }
}
